import React from "react";
import SectionHeaderTitle from "../../components/ui/SectionHeaderTitle";
import { useLanguage } from "../../context/LanguageContext";
import MovingAnimation from "../../components/NewUi/horizontalAnimation/MovingAnimation";

const PartnerSection = () => {
    const { language } = useLanguage();
    const content = {
        SectionHeaderTitle: {
            en: "Bridges Between Cultures",
            ar: "شركاؤنا في التميز والإنجاز",
            de: "Brücken zwischen Kulturen",
        },
        SectionDescription: {
            en: "We help you build strong cultural connections with the German community through learning and mastering the language.",
            ar: "بفضل تعاوننا المشترك، نرتقي معًا لصناعة إنجازات مستدامة تلبي طموحات الجميع.",
            de: "Dank unserer Zusammenarbeit schaffen wir nachhaltige Erfolge, die den Ambitionen aller gerecht werden.",
        },
    };
    return (
        <section className="bg-[#E6E1E5] min-h-[20vh] py-5 mb-10 px-3 md:px-20 flex flex-col space-y-10 relative overflow-hidden">
            <div className="flex-center-both flex-col space-y-4 text-center">
                <SectionHeaderTitle withFlag={false} title={content.SectionHeaderTitle[language]} />
                <p className="text-gray-600 w-full md:w-1/3 font-mont text-2xl mt-2">
                    {content.SectionDescription[language]}
                </p>
            </div>
            <div className="flex-center-both space-x-reverse space-x-10 flex-wrap mt-10">
                <MovingAnimation />
            </div>
        </section>
    );
};

export default PartnerSection;
